export enum RatingServiceType {
    SenderNameRegistration = 1,
    ContractRequest = 2,
    ConnectivityRequest = 3,
  }  